export default {"src":"/blog/_next/static/media/language_selector_white.0ad5c33b.svg","height":20,"width":20};